import React from 'react';
import { Pressable, Text, StyleSheet, GestureResponderEvent } from 'react-native';
import { colors, fonts, radii, spacing } from '../theme';

type Props = {
  label: string;
  active?: boolean;
  onPress?: (event: GestureResponderEvent) => void;
  onLongPress?: (event: GestureResponderEvent) => void;
  dashed?: boolean;
};

// Chip de seleção/filtro (status de projeto, sugestão de tipo, contador da
// sessão, aba insumos existentes/novo) — mesmo visual repetido em 5+ telas
// antes desta extração.
export function Chip({ label, active, onPress, onLongPress, dashed }: Props) {
  return (
    <Pressable
      onPress={onPress}
      onLongPress={onLongPress}
      style={[styles.base, dashed && styles.dashed, active && styles.active]}
    >
      <Text style={[styles.label, active && styles.labelActive]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  base: {
    borderWidth: 1.5,
    borderColor: colors.line,
    borderRadius: radii.pill,
    paddingVertical: 6,
    paddingHorizontal: spacing.md,
    marginRight: spacing.sm,
    marginBottom: spacing.sm,
    backgroundColor: colors.sandPanel,
  },
  dashed: { borderStyle: 'dashed', borderColor: colors.sage, backgroundColor: 'transparent' },
  active: { backgroundColor: colors.sageDeep, borderColor: colors.sageDeep },
  label: { fontFamily: fonts.bodyMedium, fontSize: 13, color: colors.inkSoft },
  labelActive: { color: colors.onSage },
});
